// ajaxpaginator Plugin v0.0.1 for jQuery
// =============
// Author: Denis Lyashkov
// Created: 03/11/2015
// Date: 03/11/2015
// Website:
// Description:

jQuery.fn.ajaxpaginator = function(params)
{
	init(this, params);

	function init(el, params) {

		var defaults = {
			max_autoload: 3,
			page_param: 'page',
			total_pages_value: 2,
			total_pages_container: '#ajaxpaginator_total_pages',
			load_button_container: '#ajaxpaginator_load_trigger',
			load_button_selector: '#ajaxpaginator_load_button',
			start_hash_name: '#start',
			pages_container: '#ajaxpaginator_container',
			page_container_selector: '.ajaxpaginator_page',
			footer_selection: '.ajax__footer',
			onPageLoaded: false,
			onPageState: false,
			paginatorSelector: '',
			maxElemsInPaginator: 8
		};

		var loadPage = function(pageIndex) {
			loading_state = true;
			var button_text = $(options.load_button_selector).html();
			$(options.load_button_selector).html(' &bull; &bull;  &bull; ');
			var url = getUrlWithPage(pageIndex);
			//console.log(url);
			var callBack = function(data) {
				options.onPageLoaded.call(this, data);
				loading_state = false;
				$(options.load_button_selector).html(button_text);
				footerClone.show();
			};

			$.get(url, {}, callBack);
		};

		var loadNextPage = function() {
			current_page++;
			navigateToPage(current_page, true);
			if (current_page >= options.total_pages_value) {
				$(options.load_button_container).remove();
			} else {
				$(options.load_button_selector).attr('href', getUrlWithPage(current_page + 1));
			}
		};

		var setNavigationActiveState = function($elem, state) {
			if (state) {
				$elem.removeClass('inactive');
				$elem.off('click.inactive');
			} else {
				$elem.addClass('inactive');
				$elem.on('click.inactive', function() {
					return false;
				});
			}
		};

		var getUrlWithPage = function(pageIndex, anchor) {
			if (pageIndex < 1) {
				pageIndex = 1;
			}
			params = urlhelper.setQueryStringParam(options.page_param, pageIndex, 1);
			var res = location.pathname + params;
			if (typeof anchor != 'undefined') {
				res += anchor;
			}
			return res;
		};



		var navigateToPage = function(pageIndex, dontSetPopState) {
			if (loaded_pages[pageIndex] === true) {
				scrollToPageSection(pageIndex);
			} else {
				loadPage(pageIndex);
				loaded_pages[pageIndex] = true;
			}
			if (!dontSetPopState) {
				setPageState(pageIndex);
			}
			return true;
		};

		var scrollToPageSection = function(pageIndex) {
			$(options.page_container_selector).each(function() {
				var sectionPage = $(this).data(options.page_param);
				if (sectionPage === pageIndex) {
					urlhelper.scrollTo(this);
					return false;
				}
			});
		};

		var setPageState = function(pageIndex) {
			var url = getUrlWithPage(pageIndex);
			var currenturl = urlhelper.getCurrentRequestUri();
			if (url && url !== currenturl) {
				urlhelper.add(url);

				if (options.onPageState) {
					options.onPageState.call(this);
				}
				if (options.paginatorSelector && $(options.paginatorSelector).length > 0) {
					updateFooter(pageIndex);
				}
			}
		};

		var initFooter = function() {
			var cloneResizer = function() {
				var article = footer;
				footerClone.css({
					left: article.offset().left,
					right: $(window).width() - article.offset().left - article.outerWidth(),
					bottom: 0
				});
			};

			var addAnchor = function() {
				$(this).attr('href', getUrlWithPage(parseInt($(this).text()), options.start_hash_name));
			};

			$('li a', footer).each(addAnchor);
			$('li a', footerClone).each(addAnchor);

			footerClone.css({position: 'fixed', display: 'none'});
			footerClone.addClass('clone');
			cloneResizer();
			$(window).on('scroll.ajaxfooter', function() {
				if ($(window).scrollTop() > 300) {
					if (($(window).scrollTop() + $(window).height() - footerClone.height()) >= footer.offset().top) {
						footerClone.hide();
					} else {
						footerClone.show();
					}
				} else {
					footerClone.hide();
				}
			});
			$('body').append(footerClone);
			$(window).on('resize.ajaxfooter', function() {
				cloneResizer();
			});
		};

		var updateFooter = function(page) {
			var updateNavigationLink = function($elem, page) {
				$elem.attr('href', getUrlWithPage(page, options.start_hash_name));
			};
			var $prevNav = $(options.paginatorSelector + ' a.pagination-prev');
			var $nextNav = $(options.paginatorSelector + ' a.pagination-next');

			$(options.paginatorSelector + ' .pagination li').removeClass('active');
			$(options.paginatorSelector + ' .pagination li[page="' + page + '"]').addClass('active');
			// going left and right from active link
			var direction = 1; // 1 - right, -1 - left;

			$(options.paginatorSelector).each(function() {
				$('.pagination li', this).not(':first').not(':last').not('.active').addClass('hidden');
			});
			$(options.paginatorSelector + ' .pagination li.inactive').removeClass('hidden');
			var maxElements = options.maxElemsInPaginator;
			var curPage = parseInt(page);
			var notInRange = function(page) {
				return page <= 1 || page >= options.total_pages_value;
			};
            if( options.total_pages_value < maxElements ){
                $(options.paginatorSelector + ' .pagination li[page]').removeClass('hidden');
                $(options.paginatorSelector + ' .pagination li.spacer-left').addClass('hidden');
                $(options.paginatorSelector + ' .pagination li.spacer-right').addClass('hidden');
            } else {
                for (var i = 1; i < maxElements; i++) {
                    if (notInRange(curPage) && notInRange(curPage + i * direction) && notInRange(curPage - i * direction)) {
                        break;
                    }
                    curPage = curPage + i * direction;
                    if (notInRange(curPage)) {
                        maxElements++;
                    } else {
                        $(options.paginatorSelector + ' .pagination li[page="' + curPage + '"]').removeClass('hidden');
                    }
                    if (curPage <= 2) {
                        $(options.paginatorSelector + ' .pagination li.spacer-left').addClass('hidden');
                    } else if (curPage >= options.total_pages_value - 1) {
                        $(options.paginatorSelector + ' .pagination li.spacer-right').addClass('hidden');
                    }
                    direction = -direction;
                }
            }
			if (page <= 1) {
				setNavigationActiveState($prevNav, false);
			} else {
				updateNavigationLink($prevNav, parseInt(page) - 1);
				setNavigationActiveState($prevNav, true);
			}

			if (page >= options.total_pages_value) {
				setNavigationActiveState($nextNav, false);
			} else {
				updateNavigationLink($nextNav, parseInt(page) + 1);
				setNavigationActiveState($nextNav, true);
			}
		};

		// ---- INIT ----------------------------------------------------------
		var options = $.extend({}, defaults, params);

		var autoload_iter = 0;
		var loading_state = false;
		var current_page = 1;
		var loaded_pages = [];

		current_page = urlhelper.getParamValueFromQueryString(options.page_param, 1);
		loaded_pages[current_page] = true;

		var footer = $(options.footer_selection);
		var footerClone = footer.clone();

		if ($(options.total_pages_container).length) {
			options.total_pages_value = parseInt($(options.total_pages_container).text());
		}

		if (options.paginatorSelector) {
			if ($(options.paginatorSelector).length > 0) {
				initFooter();
				updateFooter(current_page);
			} else {
				//console.log("paginatorSelector wasn't found");
			}
		}

		if (!$(options.load_button_container).length) {
			return false;
		}

		if (options.onPageLoaded === false) {
			options.onPageLoaded = function(data) {
				$(options.pages_container).append(data);
			};
		}

		$(window).bind('scroll.ajaxpaginator', function() {
			if (!loading_state && (autoload_iter < options.max_autoload) && $.inViewport($(options.load_button_selector))) {
				autoload_iter++;
				loadNextPage();
			}
		});

		$(options.load_button_selector).on('click.ajaxpaginator', function(e) {
			e.preventDefault();
			autoload_iter = 0;
			loadNextPage();
			return false;
		});

		var ajaxPaginatorScrollSpy = $(window).scrollspy({
			section_selector: options.page_container_selector,
			onChangeActive: function(el) {
				var page = parseInt($(el).data(options.page_param));
				//console.log("Change page : " + page);
				setPageState(page);
			},
			triggerDistance: 500
		});

		$(window).bind('popstate.ajaxpaginator', function(event) {
			event.preventDefault();
			ajaxPaginatorScrollSpy.disable();
			var page = urlhelper.getParamValueFromQueryString(options.page_param, 1);
			navigateToPage(page, true);
			ajaxPaginatorScrollSpy.enable();
		});

		if (window.location.hash && $(options.pages_container).length) {
			if (window.location.hash === options.start_hash_name) {
				var scrollTop = $(options.pages_container).offset().top;
				$('html,body').scrollTop(scrollTop - 60);
			}
		}
	}
};
